import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import '@fontsource-variable/montserrat';
import './index.css';
import App from './App';

dayjs.locale('es');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      <Toaster position="top-center" richColors duration={4000} />
    </BrowserRouter>
  </React.StrictMode>
);
